
      var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
const SvgClear2X = props => /*#__PURE__*/React.createElement("svg", _extends({
  width: 24,
  height: 24,
  viewBox: "0 0 24 24",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M22.512 1.505a1.662 1.662 0 0 0-2.353 0L12 9.647 3.84 1.488a1.662 1.662 0 0 0-2.352 0c-.65.65-.65 1.702 0 2.353L9.648 12l-8.16 8.16c-.65.65-.65 1.701 0 2.352.65.65 1.702.65 2.353 0L12 14.352l8.16 8.16c.65.65 1.701.65 2.352 0 .65-.65.65-1.702 0-2.353L14.352 12l8.16-8.16a1.672 1.672 0 0 0 0-2.335Z",
  fill: "var(--theme-primary, #810ea9)"
})));

      const __svgRaw = "<svg width=\"24\" height=\"24\" viewBox=\"0 0 24 24\" fill=\"none\" xmlns=\"http://www.w3.org/2000/svg\">\r\n<path fill-rule=\"evenodd\" clip-rule=\"evenodd\" d=\"M22.5119 1.50474C21.8612 0.854001 20.81 0.854001 20.1593 1.50474L12 9.64733L3.84073 1.48805C3.18999 0.837315 2.13879 0.837315 1.48805 1.48805C0.837315 2.13879 0.837315 3.18999 1.48805 3.84073L9.64733 12L1.48805 20.1593C0.837315 20.81 0.837315 21.8612 1.48805 22.5119C2.13879 23.1627 3.18999 23.1627 3.84073 22.5119L12 14.3527L20.1593 22.5119C20.81 23.1627 21.8612 23.1627 22.5119 22.5119C23.1627 21.8612 23.1627 20.81 22.5119 20.1593L14.3527 12L22.5119 3.84073C23.146 3.20667 23.146 2.13879 22.5119 1.50474Z\" fill=\"var(--theme-primary, #810ea9)\"/>\r\n\r\n</svg>";

      function __resolveCssVarsInSvg(svgMarkup) {
        if (typeof window === 'undefined' || !document?.documentElement) {
          return svgMarkup;
        }

        const htmlEl = document.documentElement;
        const bodyEl = document.body;

        function __readCustomProperty(name) {
          let v = getComputedStyle(htmlEl).getPropertyValue(name).trim();
          if (!v && bodyEl) {
            v = getComputedStyle(bodyEl).getPropertyValue(name).trim();
          }
          return v;
        }

        function __expandVarToken(fullMatch, seen) {
          if (!seen) seen = new Set();
          const m = String(fullMatch)
            .trim()
            .match(/^var\(\s*(--[^),\s]+)(?:\s*,\s*([^)]+))?\s*\)$/i);
          if (!m) return fullMatch;
          const varName = m[1];
          const fallbackRaw = m[2] != null ? String(m[2]).trim() : '';
          if (seen.has(varName)) {
            return fallbackRaw || fullMatch;
          }
          seen.add(varName);
          let specified = __readCustomProperty(varName);
          if (!specified) {
            return fallbackRaw || fullMatch;
          }
          specified = specified.trim();
          if (/^var\s*\(/i.test(specified)) {
            return __expandVarToken(specified, seen) || fallbackRaw || fullMatch;
          }
          return specified || fallbackRaw || fullMatch;
        }

        return svgMarkup.replace(
          /var\(\s*(--[^),\s]+)(?:\s*,\s*([^)]+))?\s*\)/gi,
          (fullMatch) => __expandVarToken(fullMatch, new Set())
        );
      }

      function __getSvg() {
        return __resolveCssVarsInSvg(__svgRaw);
      }

      function __getBg() {
        const resolved =__resolveCssVarsInSvg(__svgRaw);

        const encoded = encodeURIComponent(resolved)
          .replace(/'/g, '%27')
          .replace(/"/g, '%22');
        return "url('data:image/svg+xml;charset=utf-8," + encoded + "')"; }

      export default Object.assign(
        new String(__webpack_public_path__ + "Assets/clear@2x.b25f490a3bab8bb9099b16fae5bcaea5.svg"),
        {
          React: SvgClear2X,
          svgClassName: undefined,
          svg: __getSvg,
          bg: __getBg
        }
      );
      